var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterpreneur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.537,
    height: 84.537,
    viewBox: "0 0 84.537 84.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enterpreneur",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36686",
    "data-name": "Path 36686",
    d: "M9.045,2A2.818,2.818,0,0,0,6.326,4.076L2.1,19.575a2.817,2.817,0,0,0-.1.741,12.649,12.649,0,0,0,4.227,9.452v42.68a14.09,14.09,0,0,0,14.09,14.09H44.269a2.818,2.818,0,0,0,0-5.636H20.316a8.454,8.454,0,0,1-8.454-8.454V32.683a12.7,12.7,0,0,0,12.681-4.4,12.682,12.682,0,0,0,19.725,0,12.682,12.682,0,0,0,19.725,0,12.7,12.7,0,0,0,12.681,4.4v13.7a2.818,2.818,0,0,0,5.636,0V29.768a12.649,12.649,0,0,0,4.227-9.452,2.816,2.816,0,0,0-.1-.741l-4.227-15.5A2.818,2.818,0,0,0,79.492,2ZM34.406,27.361a7.045,7.045,0,0,1-7.045-7.045,2.818,2.818,0,1,0-5.636,0,7.045,7.045,0,0,1-14.081.347L11.2,7.636H77.34l3.553,13.027a7.045,7.045,0,0,1-14.081-.347,2.818,2.818,0,1,0-5.636,0,7.045,7.045,0,0,1-14.09,0,2.818,2.818,0,1,0-5.636,0,7.045,7.045,0,0,1-7.045,7.045Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36687",
    "data-name": "Path 36687",
    d: "M65.588,46.272a11.231,11.231,0,0,1-2.968,7.622,18.316,18.316,0,0,1,10.012,16.33,2.818,2.818,0,0,1-5.636,0,12.681,12.681,0,1,0-25.361,0,2.818,2.818,0,0,1-5.636,0,18.316,18.316,0,0,1,10.012-16.33,11.272,11.272,0,1,1,19.576-7.622Zm-16.907,0a5.636,5.636,0,1,1,5.636,5.636A5.636,5.636,0,0,1,48.681,46.272Z",
    transform: "translate(13.904 13.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpreneur);
export default __webpack_public_path__ + "static/media/enterpreneur.315c8999b703ff5050ee0937229e155f.svg";
export { ForwardRef as ReactComponent };